import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Location } from "@/types/location";
import { Edit, MapPin } from "lucide-react";

interface LocationsListProps {
  locations: Location[];
  onEditLocation?: (location: Location) => void;
  canEdit?: boolean;
}

const LocationsList: React.FC<LocationsListProps> = ({ locations, onEditLocation, canEdit = false }) => {
  const showEditAction = onEditLocation && canEdit;

  return (
    <div className="w-full overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Description</TableHead>
            {showEditAction && <TableHead className="w-[80px]">Actions</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {locations.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={showEditAction ? 3 : 2}
                className="h-24 text-center">
                <div className="flex flex-col items-center gap-2 text-muted-foreground">
                  <MapPin className="h-8 w-8" />
                  <span>No locations found. Add your first location!</span>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            [...locations]
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((location) => (
                <TableRow key={location.id}>
                  <TableCell className="font-medium">
                    <div className="flex items-center gap-2">
                      <MapPin className="h-4 w-4 text-agri-green" aria-hidden="true" />
                      <span>{location.name}</span>
                    </div>
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {location.description || "-"}
                  </TableCell>
                  {showEditAction && (
                    <TableCell>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => onEditLocation(location)}
                        className="h-8 w-8 p-0">
                        <Edit className="h-4 w-4" />
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default LocationsList;
